/* ==========================================================================
   EROVIA — Theme JS
   Vanilla JS only, no build step required. Uses Shopify's AJAX Cart API
   (/cart/add.js, /cart/change.js, /cart.js) so the cart drawer updates
   without a full page reload.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- header scroll state ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile nav ---------- */
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-nav-close]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ---------- review carousel(s) ---------- */
  document.querySelectorAll('[data-review-carousel]').forEach(function (carousel) {
    var items = carousel.querySelectorAll('[data-review-item]');
    var dots = carousel.querySelectorAll('[data-review-dot]');
    if (!items.length) return;
    var current = 0;
    var timer = null;

    function show(i) {
      items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      current = i;
    }
    function next() { show((current + 1) % items.length); }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        show(idx);
        resetTimer();
      });
    });

    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, 6000);
    }
    show(0);
    resetTimer();
  });

  /* ---------- product quantity selectors ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- product gallery thumbnails ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        if (main && src) main.setAttribute('src', src);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- variant picker -> price / availability update ---------- */
  document.querySelectorAll('.product-form-js').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    var priceEl = form.querySelector('[data-price]');
    var comparePriceEl = form.querySelector('[data-compare-price]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var variantsJson = form.querySelector('[data-variants-json]');
    if (!select || !variantsJson) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      variants = [];
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    select.addEventListener('change', function () {
      var variant = variants.filter(function (v) { return String(v.id) === select.value; })[0];
      if (!variant) return;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? submitBtn.getAttribute('data-add-label') : submitBtn.getAttribute('data-sold-out-label');
      }
      var hiddenIdInput = form.querySelector('input[name="id"]');
      if (hiddenIdInput) hiddenIdInput.value = variant.id;
    });
  });

  /* ---------- AJAX add to cart + cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var drawerBody = document.querySelector('[data-cart-drawer-body]');
  var drawerFooter = document.querySelector('[data-cart-drawer-footer]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
      refreshDrawer();
    });
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  overlay && overlay.addEventListener('click', closeDrawer);

  function formatMoneyCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderDrawerLine(item) {
    return (
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<img src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy">' +
        '<div>' +
          '<h3>' + item.product_title + '</h3>' +
          (item.variant_title ? '<p class="variant-title">' + item.variant_title + '</p>' : '') +
          '<button type="button" class="cart-remove" data-cart-remove="' + item.key + '">Remove</button>' +
        '</div>' +
        '<div class="qty-selector" data-drawer-qty="' + item.key + '">' +
          '<button type="button" data-drawer-qty-minus>&minus;</button>' +
          '<input type="text" readonly value="' + item.quantity + '">' +
          '<button type="button" data-drawer-qty-plus>&plus;</button>' +
        '</div>' +
        '<span class="price">' + formatMoneyCents(item.final_line_price) + '</span>' +
      '</div>'
    );
  }

  function refreshDrawer() {
    if (!drawerBody) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (!cart.items.length) {
          drawerBody.innerHTML = '<div class="cart-drawer-empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn-primary" data-cart-drawer-close>Explore the Collection</a></div>';
          if (drawerFooter) drawerFooter.style.display = 'none';
          return;
        }
        if (drawerFooter) drawerFooter.style.display = '';
        drawerBody.innerHTML = cart.items.map(renderDrawerLine).join('');
        if (drawerFooter) {
          drawerFooter.innerHTML =
            '<div class="cart-summary-box" style="max-width:none;">' +
              '<div class="subtotal"><span>Subtotal</span><span>' + formatMoneyCents(cart.total_price) + '</span></div>' +
              '<p class="note">Shipping, taxes, and discounts calculated at checkout.</p>' +
              '<a href="/checkout" class="btn-primary" style="display:block; text-align:center;">Checkout</a>' +
            '</div>';
        }
        bindDrawerLineEvents();
      })
      .catch(function () {
        drawerBody.innerHTML = '<div class="cart-drawer-empty"><p>Unable to load your bag right now.</p></div>';
      });
  }

  function bindDrawerLineEvents() {
    drawerBody.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-cart-remove'), 0);
      });
    });
    drawerBody.querySelectorAll('[data-drawer-qty]').forEach(function (wrap) {
      var key = wrap.getAttribute('data-drawer-qty');
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-drawer-qty-minus]').addEventListener('click', function () {
        var v = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
        changeLine(key, v);
      });
      wrap.querySelector('[data-drawer-qty-plus]').addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        changeLine(key, v);
      });
    });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(); });
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  document.querySelectorAll('.product-form-js').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var originalLabel = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
          openDrawer();
          refreshDrawer();
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
          window.location.href = '/cart';
        });
    });
  });

  /* Quick-add buttons on collection/featured product cards */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-quick-add');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          openDrawer();
          refreshDrawer();
        });
    });
  });

  /* initialize cart count on load */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});

});
